import PropertyIcon from '@/common/assets/icons/property.svg?react';
import BodyIcon from '@/common/assets/icons/bodyIcon.svg?react';
import InitialIcon from '@/common/assets/icons/initialIcon.svg?react';
import { RenderIconTypes } from '@/modules/FileDetail/components/renderIcon/RenderIcon.types.ts';
import React from 'react';

const RenderIcon = ({ fileType }: RenderIconTypes) => {
  const fileTypeIcon: Record<string, React.JSX.Element> = {
    initial: <InitialIcon />,
    property: <PropertyIcon />,
    body: <BodyIcon />,
  };
  return fileTypeIcon[fileType];
};
export default RenderIcon;
